import * as React from "react";
// Styles
import { useTheme, Icon, TooltipHost } from "@fluentui/react";
import { getClassNames, getStyles } from "./LabelTag.styles";
/**
 * Tag for rendering the label
 */ export const LabelTag = (props)=>{
    const { index, title, isCollapsed, showBorder, isHovered, iconProps, styles, onClick, onMouseEnter, onMouseLeave } = props;
    const theme = useTheme();
    const classNames = getClassNames(getStyles(theme, index, isCollapsed, showBorder, isHovered, styles));
    return /*#__PURE__*/ React.createElement(TooltipHost, {
        content: title
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.root,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, !isCollapsed && /*#__PURE__*/ React.createElement(React.Fragment, null, iconProps && /*#__PURE__*/ React.createElement("span", {
        className: classNames.labelIcon
    }, /*#__PURE__*/ React.createElement(Icon, iconProps)), /*#__PURE__*/ React.createElement("span", {
        className: classNames.labelTitle
    }, title))));
};
